import React, { useState } from 'react';
import './App.css'; // Import CSS file for styling

function img_loaded() {
  // Handle image loaded event
}

function App() {
  const [url, setUrl] = useState('');
  const [response, setResponse] = useState('');

  const handleInputChange = (e) => {
    setUrl(e.target.value);
  };


  const fetchData = async() => {
    setResponse("");
    try{
      let response = await fetch(url);
      let data = await response.text();
      setResponse("We Have A Connection");
      console.log(data);
    }
    catch(e){

      try{
       
      let response = await fetch(url);
      let data = await response.json();
      setResponse("We Have A Connection");
      console.log(data);

      }

      catch(e){
        setResponse(e);
      console.error('Error fetching data:', e);

      }
    }

    
   
    
  };

  // const fetchData = () => {
  //   fetch(url)
  //     .then(response => response.json())
  //     .then(data => {
  //       setResponse(data);
  //       console.log(data);
  //     })
  //     .catch(error => console.error('Error fetching data:', error));
  // };

  return (
    <div className="container">
      <h1 className="title">Fetch Data from URL</h1>
      <div className="input-container">
        <input 
          type="text" 
          placeholder="Enter URL" 
          value={url} 
          onChange={handleInputChange} 
          className="url-input" 
        />
        <button onClick={fetchData} className="fetch-button">Fetch Data</button>
      </div>

      <div className="response-container">
        <div dangerouslySetInnerHTML={{__html:response}}>
          {/* {JSON.stringify(response, null, 2)} */}
          </div>
        {/* <pre>{response}</pre> */}

      </div>
    </div>
  );
}

export default App;
